import { AnyAction } from 'redux';
import {
  ApplicationNctProps,
  CLEAR_APPLICATION,
  GET_NCT_APPLICATION_SUCCESS,
  UPDATE_NCT_APPLICATION_SUCCESS,
} from '../types/nct';

export type ApplicationNctStateProps = {
  application: ApplicationNctProps | null;
};

const initialState: ApplicationNctStateProps = {
  application: null,
};

function applicationNctReducer(
  state = initialState,
  action: AnyAction
): Partial<ApplicationNctStateProps> {
  switch (action.type) {
    case GET_NCT_APPLICATION_SUCCESS:
    case UPDATE_NCT_APPLICATION_SUCCESS:
      return {
        ...state,
        application: action.body,
      };
    case CLEAR_APPLICATION:
      return initialState;
    default:
      return state;
  }
}

export default applicationNctReducer;
